import classNames from "classnames"

import TextButton from "../../elements/V2/Buttons/TextButton"
import GatsbyStoryblokImage from "../../elements/V2/GatsbyStoryblokImage"
import Typography from "../../elements/V2/Typography"

import { Color } from "@constants/V2/color"
import {
  getAccentColor,
  getBackgroundColorClass,
  getGradientFromColorClass,
  getGradientToColorClass,
} from "@utils/V2/color"
import React from "react"

export type IconCTAPopupProps = {
  text: string
  ctaText?: string
  ctaLink?: string | YocoCom.YocoLink
  icon?: string
  iconAlt?: string
  backgroundColor: Color
  primaryBorderColor?: Color
  secondaryBorderColor?: Color
}

const IconCTAPopup = ({
  text,
  ctaText,
  ctaLink,
  icon,
  iconAlt,
  backgroundColor,
  primaryBorderColor,
  secondaryBorderColor,
}: IconCTAPopupProps) => {
  const textColor = getAccentColor(backgroundColor)
  const fromColor = primaryBorderColor ?? Color.Blue
  const toColor = secondaryBorderColor ?? fromColor

  return (
    <div
      className={classNames(
        "rounded-[14px] bg-gradient-to-br p-[1.5px] shadow-lg",
        getGradientFromColorClass(fromColor),
        getGradientToColorClass(toColor)
      )}
    >
      <div
        className={classNames(
          "flex items-start gap-20 rounded-[12.5px] py-20 pl-20 pr-48",
          getBackgroundColorClass(backgroundColor)
        )}
      >
        {!!icon && (
          <div className="h-40 w-40 shrink-0 overflow-hidden rounded-8">
            <GatsbyStoryblokImage
              image={icon}
              aspectRatio="1:1"
              alt={iconAlt || "Popup icon"}
            />
          </div>
        )}

        <div className="flex flex-col gap-8">
          <Typography
            text={text}
            weight="book"
            font="grotesk"
            color={textColor}
            size="body-sm-fixed"
          />
          {!!ctaText && (
            <TextButton
              style="text"
              uppercase={false}
              text={ctaText}
              linkUrl={ctaLink}
              textSize="body-sm-fixed"
              color={Color.Blue}
              className="-mb-6"
            />
          )}
        </div>
      </div>
    </div>
  )
}

export default IconCTAPopup
